import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import * as globals from '../../settings';
import {LotteriesService} from '../../lotteries.service';
import {LoginService} from '../../shared/navigation/login.service';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {UserService} from '../../_services/user.service';
import {CurrencyService} from '../../_services/currency.service';
import {Subscription} from 'rxjs';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {JsontranslateService} from '../../_services/jsontranslate.service';
import {Router} from '@angular/router';
import {ParamsService} from '../../_services/params.service';
import {ActionService} from '../../_services/action.service';
import {GetPaymentMethodsService} from '../../shared/paymentMethod/get-payment-methods.service';

@Component({
    selector: 'app-casino-welcome',
    templateUrl: './casino-welcome.component.html',
    styleUrls: ['./casino-welcome.component.scss']
})
export class CasinoWelcomeComponent implements OnInit, OnDestroy {
    showModal: boolean;
    page: string;
    pageLanguage: string;
    oldLang: string;
    isMobile: boolean;
    disableEverything: boolean;
    bannerDetails: any;
    name: string;
    gender: string;
    currency: any;
    brand = globals.brand;
    languagePage: string;
    runGetCasinoWelcome: Subscription;
    getSuccessAddPaymentMethodStatus: Subscription;
    onlyPmStep: Subscription;
    showLang: any;
    userNeedIncreaseBalance: Subscription;
    userShouldIncreaseBalance: boolean;
    waitBeforeClose: boolean;

    constructor(public lotteryService: LotteriesService,
                public subscriptionsService: SubscriptionsService,
                private loginService: LoginService,
                public userService: UserService,
                private currencyService: CurrencyService,
                private translate: TranslateService,
                private jsontranslate: JsontranslateService,
                private renderer: Renderer2,
                private router: Router,
                private paramsService: ParamsService,
                private actionService: ActionService,
                private gpmService: GetPaymentMethodsService) {
        this.currency = this.currencyService.currency;
        this.showModal = false;
        this.page = 'casino-welcome';

        this.runGetCasinoWelcome = this.subscriptionsService.getCasinoWelcome().subscribe(data => {
            if (data) {
                this.getData();
            }
        });
        this.languagePage = this.translate.currentLang;
        this.jsontranslate.loadTranslations('CasinoWelcomeComponent', this.translate.currentLang);

        this.userShouldIncreaseBalance = false;
        this.userNeedIncreaseBalance = this.subscriptionsService.getUserNeedIncraseBalance().subscribe(data => {
            if (data && data !== -1) {
                this.userShouldIncreaseBalance = true;
            } else {
                this.userShouldIncreaseBalance = false;
            }
        });
        this.waitBeforeClose = false;
    }

    ngOnInit() {
        setTimeout(() => {
            if (this.openModal_params('incentiveCode')) {
                this.getData();
            }
        }, 100);

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.languagePage = this.translate.currentLang;
            this.jsontranslate.loadTranslations('FreshRegistrationComponent', this.translate.currentLang);
        });
    }

    ngOnDestroy() {
        if (this.runGetCasinoWelcome) {
            this.runGetCasinoWelcome.unsubscribe();
        }
        if (this.onlyPmStep) {
            this.onlyPmStep.unsubscribe();
        }
        if (this.getSuccessAddPaymentMethodStatus) {
            this.getSuccessAddPaymentMethodStatus.unsubscribe();
        }
        if (this.userNeedIncreaseBalance) {
            this.userNeedIncreaseBalance.unsubscribe();
        }
    }

    checkTime() {
        if (this.subscriptionsService.isFreshRegisteredForFDB) {
            this.subscriptionsService.isFreshRegisteredForFDB = false;
            return true;
        } else {
            return false;
        }
    }

    getData() {
        const fric = localStorage.getItem('emitFreshRegisteredInCasino');
        const itsAfterRegistration = this.checkTime();
        if (this.page && this.userService.userData && fric && !this.userShouldIncreaseBalance && itsAfterRegistration) {
            localStorage.removeItem('emitFreshRegisteredInCasino');
            const sendData = {};
            this.pageLanguage = localStorage.getItem('pageLanguage');
            if (!this.pageLanguage) {
                this.pageLanguage = 'de';
            }
            this.oldLang = this.pageLanguage;
            sendData['language'] = this.pageLanguage;
            sendData['page'] = this.page;
            if (window.innerWidth < 991) {
                this.isMobile = true;
                sendData['device'] = 'Mobile';
            } else {
                this.isMobile = false;
                sendData['device'] = 'Desktop';
            }
            const playerDetails = JSON.parse(localStorage.getItem('playerDetails'));
            if (playerDetails && playerDetails.MemberID) {
                sendData['loggedIn'] = true;
            } else {
                sendData['loggedIn'] = false;
            }
            this.lotteryService
                .postData(globals.appDomain + '/banner/carousel/bannerCarousel_' + this.page + '_' + sendData['device'] +
                    '_' + sendData['loggedIn'] + '.json', this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    response => {
                        if (response.apiErrorMessage || response.status !== 200 || response.message.banners.length === 0) {
                            this.disableEverything = true;
                            this.showModal = false;
                        } else {
                            this.bannerDetails = response.message.banners[0];
                            this.showModal = true;
                            this.renderer.addClass(document.body, 'modal-open');
                            this.name = this.userService.userData.FirstName;
                            if (this.userService.userData.Gender === 'Mr.') {
                                this.gender = 'man';
                            } else {
                                this.gender = 'woman';
                            }
                        }
                    }
                );
        }
    }

    cta() {
        this.waitBeforeClose = true;
        setTimeout(() => {
            const actionValue = this.bannerDetails.ActionValue;
            this.showLang = this.translate.currentLang;
            const av = actionValue.split('?');
            av[0] = av[0].replace('/', '');
            this.router.navigate(['/' + this.showLang, av[0]]).then(() => {
                const url = window.location.toString().split('?');
                window.history.pushState('', '', url[0] + '?' + av[1]);
                const params = av[1].split('&');
                const sendParams = [];
                params.forEach((element, index) => {
                    const param = element.split('=');
                    sendParams[param[0]] = param[1];
                });

                this.paramsService.checkForParams(sendParams);

                this.userService.sendSomeCookies(sendParams['incentiveCode']).then(val => {
                    this.gpmService.getPaymentMethods().then(pms => {
                        this.actionService.goToAction(sendParams, this.showLang, this.userService.userData);
                        if (this.userService.userData
                            && this.userService.userData.Balance === '0.00'
                            && this.userService.userData.BonusBalance === '0.00'
                            && this.userService.userData.RealBalance === '0.00') {
                            this.subscriptionsService.triggerDepositService(true);
                        }
                        this.waitBeforeClose = false;
                        this.closeModal();
                    });
                });
            });
        }, 1000);
    }

    closeModal() {
        this.subscriptionsService.closeModalNow(true);
        this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
        setTimeout(() => {
            this.showModal = false;
            this.renderer.removeClass(document.body, 'modal-open');
        }, 1500);
    }

    openModal_params(param) {
        const url = new URL(document.location.href);
        const incentiveCode = url.searchParams.get(param);
        if (incentiveCode) {
            return false;
        } else {
            return true;
        }
    }

}
